function injectStyle (ssrContext) {
  require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":0,\"remove\":true}!css-loader!../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-45d266b6\",\"scoped\":false,\"hasInlineConfig\":false}!less-loader?{\"globalVars\":{\"museUiTheme\":\"'/usr/src/app/node_modules/muse-ui/src/styles/themes/variables/default.less'\"}}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Payment.vue")
}
var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Payment.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-45d266b6\",\"hasScoped\":false}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Payment.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/views/Payment/Payment.vue
// module id = 3513
// module chunks = 1